import { Injectable } from 'angular-ts-decorators';

import { Legacy } from '@shared/app/scripts/services/legacy';

/**
 * Service to read SKU data from FoxPro.
 */
@Injectable('legacySku')
export class LegacySku {
  constructor(
    private legacy: Legacy,
    private $q: ng.IQService,
  ) {
    'ngInject';
  }

  get(barcode: string) {
    return this.legacy.getSku(barcode).then((data: any) => {
      const processedProduct: {
        saleprice?: number;
        price?: number;
        sizeLabel?: string;
        articleDescription?: string;
        articleCode?: string;
        group?: string;
        brand?: string;
        collection?: string;
        barcode?: string;
        error?: string;
        color?: string;
        vat?: number;
        image?: string;
      } = {};

      if (!angular.isObject(data)) {
        return this.$q.reject('Product is missing');
      }

      processedProduct.saleprice = parseFloat(data.saleprice);
      processedProduct.price = parseFloat(data.sellprice);
      processedProduct.sizeLabel = data.sizelabel;
      processedProduct.articleDescription = data.articledescription;
      processedProduct.articleCode = data.articlecode;
      processedProduct.group = data.articlegroup;
      processedProduct.brand = data.brand;
      processedProduct.collection = data.collection;
      processedProduct.barcode = data.barcode;
      processedProduct.error = data.error;
      processedProduct.color = `${data.colorFamily} ${data.subcolor}`;
      processedProduct.vat = parseFloat(data.vat);
      processedProduct.image = data.image;

      return processedProduct;
    });
  }
}
